import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import api from '../../services/api';
import {
  Grid,
  FormGroup,
  TextField,
  Card,
  CardContent,
  Tooltip,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import * as Yup from 'yup';
import Progress from '../../components/Progress';
import { useDispatch, useSelector } from 'react-redux';

import { setDisable } from '../../redux/disable';
import { setLoading } from '../../redux/loading';
import Success from '../../components/Snack/Success';
import Error from '../../components/Snack/Error';
import { useStyles } from '../../components/Styles';
import GroupButton from '../../components/Buttons/ButtonGroup';
import AutocompleteField from '../../components/Inputs/Autocomplete/Autocomplete';
import NumberFormat from 'react-number-format';
import styles from './styles.module.css';
import styleGlobal from '../../Global.module.css';
import InfoIcon from '@mui/icons-material/Info';

function Stock() {
  const location = useLocation();
  const [openProgress, setOpenProgress] = useState(false);
  const [unities, setUnities] = useState([]);
  const [selectedUnity, handleSelectedUnity] = useState(null);
  const [selectedSupply, handleSelectedSupply] = useState(null);
  const [listSupply, setListSupply] = useState([]);
  const [inputSupply, setInputSupply] = useState(false);

  const disable = useSelector((state) => state.disable.disable);
  const error = Error();
  const success = Success();
  const history = useHistory();
  const dispatch = useDispatch();
  let { id } = useParams();
  const classes = useStyles();

  useEffect(() => {
    if (location.state !== undefined) {
      if (location.state.customData) {
        setData(location.state.customData);
        formik.setFieldValue('id', null);
      } else if (location.state.data) {
        id = location.state.id;
        setData(location.state.data);
      }
    }
  }, [location]);

  function setData(data) {
    formik.setValues(data);

    setInputSupply(true);
    handleSelectedUnity(data.unity);
    handleSelectedSupply(data.supply);

    if (data.quantity < 0) {
      formik.values.quantity = 0;
    }
  }

  const formik = useFormik({
    initialValues: {
      supply: { name: '' },
      quantity: '',
      unity: null,
    },
    validationSchema: Yup.object({
      quantity: Yup.string()
        .min(0, 'Precisa ser acima de 0')
        .max(
          9,
          'O valor está acima da quantidade de animais existentes',
        )
        .test(
          'max-value',
          'O valor não pode ser maior que 100.000.000',
          (value) => {
            if (!value) return true;
            const numericValue = Number(value.replace(/\./g, ''));
            return numericValue <= 100000000;
          },
        ),
      unity: Yup.object().required('Campo Obrigatório').nullable(),
    }),
    onSubmit: (values) => {
      dispatch(setDisable(true));
      dispatch(setLoading(true));
      request(values);
    },
  });

  useEffect(() => {
    api.get('/unities/').then((unities_) => setUnities(unities_.data));
  }, []);

  useEffect(() => {
    async function load() {
      setOpenProgress(true);

      const respSupplies = await api.get('/supplies');
      setListSupply(respSupplies.data);

      setOpenProgress(false);
    }
    load();
  }, []);

  // carrega o Stock caso tenha id, do contrario carrega vazio para cadastrar um novo

  async function request(data) {
    // envia os dados para api salvar no banco
    try {
      id
        ? await api.put(`/stocks/${id}`, { ...data })
        : await api.post('/stocks', { ...data });
      success();
      history.push('/stocks');
    } catch (err) {
      error();
    }
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  }

  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#FFFFFF',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 300,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #0367bf',
    },
  }))(Tooltip);

  return (
    <header className={styleGlobal.headerGlobal}>
      {openProgress ? <Progress /> : null}
      <Card style={{ padding: '2rem', borderRadius: '20px' }}>
        <form onSubmit={formik.handleSubmit}>
          <div className={classes.root}>
            <h2 style={{ marginBottom: '2rem' }}>
              Dados de Estoque
              {' '}
              <HtmlTooltip
                title={(
                  <>
                    Nessa tela é possível ver a quantidade de cada insumo que você registrou anteriormente na tela de insumos. As quantidades são incrementadas sempre que mais insumos são comprados.
                  </>
                )}
                placement="right"
                arrow
                interactive
              >
                <InfoIcon color="primary" fontSize="inherit" />
              </HtmlTooltip>
            </h2>
            <CardContent style={{ padding: '0rem' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FormGroup>
                    <AutocompleteField
                      label="Insumo"
                      data={listSupply}
                      value={selectedSupply}
                      getOptionLabel="name"
                      onChange={(e, v) => {
                        handleSelectedSupply(v);
                      }}
                      disabled={inputSupply}
                    />
                  </FormGroup>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <FormGroup>
                    <NumberFormat
                      inputProps={{ maxLength: 12 }}
                      required
                      fullWidth
                      label="Quantidade"
                      variant="outlined"
                      name="quantity"
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={4}
                      isAllowed={(inputObj) => inputObj.value <= 999999999}
                      allowNegative={false}
                      value={formik.values.quantity}
                      onValueChange={(values) => {
                        formik.setValues({
                          ...formik.values,
                          quantity: values.value,
                        });
                      }}
                      customInput={TextField}
                      onBlur={formik.handleBlur}
                      error={formik.touched.quantity && formik.errors.quantity}
                      helperText={
                        formik.touched.quantity && formik.errors.quantity
                      }
                    />
                  </FormGroup>
                </Grid>

                <Grid item xs={12} sm={3}>
                  <FormGroup>
                    <AutocompleteField
                      label="Unidade"
                      data={unities}
                      value={selectedUnity}
                      getOptionLabel="name"
                      onChange={(e, v) => {
                        handleSelectedUnity(v);
                        formik.values.unity = v;
                      }}
                      formik={formik}
                      error="unity"
                    />
                  </FormGroup>
                </Grid>
              </Grid>
            </CardContent>
          </div>

          <GroupButton
            // deleteRoute={"/stocks/"}
            // routeDelete={"/stocks"}
            returnRoute="/stocks"
            id={id}
            disableTemporary
            disable={disable}
            message="A exclusão desse estoque pode levar a exclusão de objetos que dependam dela. Tem certeza que deseja excluir?"
          />
        </form>
      </Card>
    </header>
  );
}

export default Stock;
